// extracted by mini-css-extract-plugin
module.exports = {"mega":"Typography-module--mega--1KrAz","heading":"Typography-module--heading--3K-hP","paragraph":"Typography-module--paragraph--3RXwW"};